import { selectIsOfferRedesignExperimentActive } from 'shared/selectors/abExperiments';

import { IState } from '../store';

export const selectIsOfferPageCommercialRedesignSelector = (state: IState) => {
  const { isOfferPageCommercialRedesign } = state;
  const isRedesignABActive = selectIsOfferRedesignExperimentActive(state);

  return isOfferPageCommercialRedesign && isRedesignABActive;
};
